import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { reportError } from 'automation-ui-template/_internal/errors/utils/reportError';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Usage:
 *   <ErrorBoundary boundaryName="MyComponent_MyError" renderError={() => <MyError />}}>
 *     <MyComponent />
 *   </ErrorBoundary>
 */
class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      caughtError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      caughtError: true
    };
  }
  componentDidCatch(error, info) {
    const {
      boundaryName
    } = this.props;
    const errorWithInfo = error;
    errorWithInfo.info = JSON.stringify(info);
    reportError({
      error: errorWithInfo,
      tags: {
        errorBoundaryName: boundaryName
      }
    });
  }
  render() {
    const {
      children,
      renderError
    } = this.props;
    const {
      caughtError
    } = this.state;
    if (caughtError) {
      if (renderError) {
        return renderError(caughtError);
      }
      return /*#__PURE__*/_jsx(UIErrorMessage, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "error.title"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "error.body"
        })
      });
    }
    return children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node,
  renderError: PropTypes.func,
  boundaryName: PropTypes.string
};
ErrorBoundary.defaultProps = {
  boundaryName: ''
};
export default ErrorBoundary;